import { DeleteIcon, EditIcon, MinusIcon, PinIcon, PlusIcon, UnPinIcon } from "Assets/icons";
import ConfirmationPop from "components/Modals/ConfirmationPop";
import { FieldArray, Formik } from "formik";
import { successMessageToast, userFullName } from "helpers/common";
import { useState } from "react";
import { Button, Col, Form, Row } from "react-bootstrap";
import { useCreateNoteMutation, useDeleteNoteMutation, usePinNoteMutation, useUpdateNoteMutation } from "store/services/note";
import LoadingOverlay from "../LoadingOverlay";
import { cloneDeep } from "lodash";
import p1 from "../../../Assets/images/user.png";
import moment from "moment";
import ViewAllNotes from "components/Modals/ViewAllNotesPop";
import { NoRecordFound } from "components/Common/Common";

const singleNote = { note: "", disable: false };

const NotesComponent = ({ client_id, heading = "Notes", showAllMessage = "Show all notes", disableAdd, disableEdit, disablePin, buttonName = "Create Note", allRecordsHeading = "All Notes", notes = [{ ...singleNote }], module, ...props }) => {

    const notesArray = notes?.length ? notes?.map(i => ({ ...i, disable: true })).sort((a, b) => a.pin_top == "Y" ? -1 : 1) : [{ ...singleNote }];
    const [showAllNotes, setShowAllNotes] = useState(false);
    const [isCreate, setIsCreate] = useState(false)

    const noteToShow = notes?.find(x => x?.pin_top == "Y") || notes?.find(x => x?.id);
    return (
        <div className="w-100">
            <ViewAllNotes
                allRecordsHeading={allRecordsHeading}
                disablePin={disablePin}
                disableAdd={disableAdd}
                disableEdit={disableEdit}
                isCreate={isCreate}
                show={showAllNotes}
                setShow={setShowAllNotes}
                notes={notesArray}
                client_id={client_id}
                module={module}
            />
            <Row className="align-items-center my-3" >
                <Col lg="12">
                    
                        <div className="top pb-3 d-flex justify-content-between align-items-center">
                            <h6 className="m-0 themeBlue fw-sbold">{heading}</h6>
                    {       !disableAdd &&  <Button
                                onClick={() => { setIsCreate(true); setShowAllNotes(true) }}
                                style={{ padding: "0px 8px", height: "35px" }}
                                className="d-flex align-items-center justify-content-center commonBtn"
                            >
                                {buttonName}
                            </Button>
                    }
                        </div>
                    <Row>
                        {noteToShow ? <Col lg="12" sm="12">
                            <div className="student-details-main-box p-3 rounded shadow" style={{ background: "rgba(253, 217, 202, 0.31)", border: "1px solid rgb(61, 160, 170)" }}>
                                <div className="student-details-main-box-inner">
                                    <div className="student-details-main-box-heading"
                                    >
                                    </div>
                                </div>
                                <p style={{ fontSize: "16px", fontWeight: "700", marginBottom: "6px" }}>{noteToShow?.note}</p>
                                <div className="student-details-main-notes">
                                    <div className="student-details-inner-notes d-flex align-items-center gap-2" style={{ fontSize: "12px" }}>
                                        <img
                                            src={noteToShow?.noteOwner?.therapist_detail?.profile_picture || p1}
                                            alt=""
                                            className="img-fluid object-fit-cover rounded-circle border border-white"
                                            style={{ height: 30, width: 30 }}
                                        />
                                        {userFullName(noteToShow?.noteOwner)}
                                    </div>
                                    <div className="student-details-inner-notes forteen">
                                        {moment(noteToShow?.createdAt).format("DD/MM/YYYY")}
                                    </div>
                                </div>
                            </div>
                        </Col> : <div><NoRecordFound space /></div>}
                        <Col lg="12" sm="12" className="mt-2">
                            <div className="w-100 d-flex justify-content-end">
                                <p
                                    className="forteen"
                                    style={{ color: "#b46c9f", fontSize: "14px", cursor: "pointer" }}
                                    onClick={() => { setIsCreate(false); setShowAllNotes(true) }}
                                >
                                    {showAllMessage}
                                </p>
                            </div>
                        </Col>
                    </Row>
                </Col>
            </Row>
        </div >
    );

};

export default NotesComponent;